import { render, staticRenderFns } from "./UserReportersTab.vue?vue&type=template&id=c1a538e8"
import script from "./UserReportersTab.vue?vue&type=script&lang=js"
export * from "./UserReportersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports